import React, { useState, useEffect, useRef } from "react";
import Layout from "../../../Components/Layout/layout";
import dashboardclasses from "../../dashboard.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "../../../App.css";
import { css } from "@emotion/react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
import Moment from "react-moment";
import { useNavigate, useSearchParams } from "react-router-dom";
import { GrFormView } from "react-icons/gr";
import Addshipment from "./CreateShipment";
import Shipment from "./shipmentDetails";
function Products() {
    const Navigate = useNavigate();
    const [tableLoad, setTableLoad] = useState(true);
    const [params, setparams] = useSearchParams();
    let [loading, setLoading] = useState(true);
    const [Navactive, setNavactive] = useState("Active");
    const [pageCount, setpageCount] = useState(1);
    const [orders, setOrders] = useState([]);
    const [ordersSearch, setOrdersSearch] = useState([]);
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const headerstyles = {
        color: "#707275",
        fontWeight: 700,
        fontSize: "0.8rem",
    };
    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;

    const getorders = (status) => {
        setTableLoad(true);
        Services.ServiceOrders("GET", null, token, status)
            .then((res) => {
                console.log(res);
                setLoading(false);
                // setTabloader(false);
                setTableLoad(false);

                if (res.Status === 1) {
                    setOrders(res.Orders);
                    setOrdersSearch(res.Orders);
                } else if (res.Status === 0) {
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    useEffect(() => {
        setNavactive(params.get("tab"));
        getorders(params.get("tab"));
        if (params.get("page")) {
            setpageCount(Number(params.get("page")));
            // console.log(typeof params.get("page"));
        }
    }, []);
    useEffect(() => {
        let timer = setTimeout(() => {
            setTableLoad(false);
        }, 150);
        return () => {
            clearTimeout(timer);
        };
    }, [ordersSearch]);
    const Idformatter = (cell, cellcontent, index, formatExtraData) => {
        return (
            <div>
                <p className={dashboardclasses["idformatter"]}>{cell}</p>
            </div>
        );
    };
    const dateformatter = (cell, cellcontent) => {
        const date = new Date(cell);

        return <Moment format="MMMM Do YYYY">{date}</Moment>;
    };

    const priceFormatter = (cell) => {
        //className={dashboardclasses["priceformatter"]}
        return (
            <div className={dashboardclasses["price-wrapper"]}>
                <p>₹ {cell}</p>
            </div>
        );
    };

    let columns = [
        {
            dataField: "orderid",
            text: "ORDER ID",
            sort: false,
            // cell: (row, index) => index + 1,
            formatter: Idformatter,
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "username",
            text: "USER DETAILS",
            sort: false,
            formatter: (cell, cellContent) => {
                return (
                    <>
                        {cell},<br />
                        {cellContent.mobile}
                    </>
                );
            },
            // cell: (row, index) => index + 1,
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },

        {
            dataField: "DeliveredDatetime",
            text: "DELIVERY DATE",
            sort: false,
            // formatter: (cell) => (
            //     <Moment format="DD-MM-YYYY HH:MM A">{new Date(cell)}</Moment>
            // ),
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "vendormobile",
            text: "VENDOR MOBILE",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },

        {
            dataField: "bookdate",
            text: "BOOK DATE AND TIME",
            sort: false,
            formatter: (cell, cellContent) => {
                return ` ${cell}
                    ${
                        cellContent?.booktime?.length > 0 &&
                        `, ${cellContent.booktime}`
                    }`;
            },
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "orderTotal",
            text: "AMOUNT",
            sort: false,
            formatter: priceFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "paymenttype",
            text: "PAYMENT",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "created",
            text: "ORDER DATE",
            sort: false,
            formatter: dateformatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
    ];
    if (Navactive != "Delivered") {
        columns = columns.filter(
            (column) => column.dataField != "DeliveredDatetime"
        );
    }
    const pagination = paginationFactory({
        page: pageCount,
        sizePerPage: 8,
        lastPageText: ">>",
        firstPageText: "<<",
        nextPageText: ">",
        prePageText: "<",
        hideSizePerPage: true,
        showTotal: true,
        alwaysShowAllBtns: true,
        onPageChange: function (page, sizePerPage) {
            window.scrollTo({ top: 10, behavior: "instant" });
            Navigate(`/service-orders?tab=${Navactive}&page=${page}`);
        },
        onSizePerPageChange: function (page, sizePerPage) {
            console.log("page", page);
            console.log("sizePerPage", sizePerPage);
        },
    });
    const defaultSorted = [
        {
            dataField: "name",
            order: "desc",
        },
    ];
    const searchHandler = (e) => {
        const search = orders.filter((item) =>
            String(item.mobile).includes(e.target.value)
        );
        setOrdersSearch(search);
    };

    const navactivehandler = (e) => {
        let status = e.currentTarget.getAttribute("id");
        setNavactive(status);

        setparams({ page: 1, tab: status });
        getorders(status);
    };

    const emptyDataMessage = () => {
        return "No Data to Display";
    };
    const tableRowEvents = {
        onClick: (e, row, rowIndex) => {
            e.preventDefault();
            Navigate(`/Service-Order-details?id=${row._id}`);
            console.log(row);
        },
    };
    return (
        <>
            <Layout Active={"ServiceOrders"}>
                <div className={dashboardclasses["dashboard-rightside"]}>
                    <div className={dashboardclasses.CategoryWrapper}>
                        <h3>Service Orders</h3>
                        {loading ? (
                            <div className={dashboardclasses["loader"]}>
                                <ScaleLoader
                                    color={"black"}
                                    loading={true}
                                    css={override}
                                    size={150}
                                />
                            </div>
                        ) : (
                            <>
                                <div
                                    className={
                                        dashboardclasses["category-form"]
                                    }>
                                    <input
                                        type={"text"}
                                        placeholder="search by Mobile number"
                                        onChange={searchHandler}
                                    />
                                </div>
                                <div
                                    className={
                                        dashboardclasses["orders-navbar"]
                                    }>
                                    <button
                                        id="Active"
                                        className={
                                            Navactive == "Active" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Active
                                    </button>
                                    <button
                                        id="Started"
                                        className={
                                            Navactive == "Started" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Started
                                    </button>
                                    <button
                                        id="Delivered"
                                        className={
                                            Navactive == "Delivered" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Delivered
                                    </button>
                                    <button
                                        id="Cancelled"
                                        className={
                                            Navactive == "Cancelled" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Cancelled
                                    </button>
                                    <button
                                        id="Payment-Failed"
                                        className={
                                            Navactive == "Payment-Failed" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Payment Failed
                                    </button>
                                </div>

                                {tableLoad ? (
                                    <div className={dashboardclasses["loader"]}>
                                        <ScaleLoader
                                            color={"black"}
                                            loading={true}
                                            css={override}
                                            size={150}
                                        />
                                    </div>
                                ) : (
                                    <div className="category-table">
                                        <BootstrapTable
                                            bootstrap4
                                            keyField="id"
                                            data={ordersSearch}
                                            columns={columns}
                                            defaultSorted={defaultSorted}
                                            pagination={pagination}
                                            wrapperClasses="table-responsive"
                                            noDataIndication={emptyDataMessage}
                                            rowEvents={tableRowEvents}
                                        />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Products;
